export default "__VITE_ASSET__Kti68NEK__"